// extracted by mini-css-extract-plugin
export default {"controlTitle":"ECommerceProductControl_controlTitle__rblNn"};